import { dspRepository } from './Repository'

const resource = '/get-product'
export default {
  getProduct() {
    return dspRepository.post(`${resource}`, {
      domain: 'point-barre',
      id: 1,
    }, {
      transformRequest: [(data) => JSON.stringify(data)],
    })
  },
}